import { useStringsContext } from '../../../../contexts/strings';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { StaffMemberInternal } from '../types';

interface Props {
  staff: StaffMemberInternal[];
  selectedMember: StaffMemberInternal | null;
  onSelectMember: (member: StaffMemberInternal) => void;
  disabled?: boolean;
}

const StaffMemberSelect = ({ staff, selectedMember, onSelectMember, disabled }: Props) => {
  const { strings } = useStringsContext();

  const onChange = (event: SelectChangeEvent) => {
    const clId = event.target.value as string;
    const newSelectedPlayer = staff.find((member) => member.clId === clId);
    if (newSelectedPlayer) {
      onSelectMember(newSelectedPlayer);
    }
  };

  return (
    <FormControl fullWidth>
      <InputLabel size="small">{strings.staff.selectStaffMember}</InputLabel>
      <Select
        size="small"
        value={selectedMember?.clId || ''}
        label={strings.staff.selectStaffMember}
        onChange={onChange}
        disabled={disabled}
      >
        {staff.map((member) => (
          <MenuItem key={member.clId} value={member.clId}>
            {member.displayName || member.fullName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StaffMemberSelect;
